// All 9 features shown on every plan card (ChatGPT-style comparison)
const ALL_FEATURES = [
  { ico: "🧑‍💼", text: "Personalised Coaching & Lifestyle Management" },
  { ico: "🔬", text: "₹2,000 Diagnostics Wallet (annual)" },
  { ico: "🧬", text: "65+ Tests Comprehensive Health Check-up" },
  { ico: "📱", text: "GOQii Wellness App" },
  { ico: "🏆", text: "Engagement, Leaderboards & Quarterly Challenges" },
  { ico: "🩺", text: "₹2,000 In-person Consultation Wallet (35+ specialties)" },
  { ico: "📞", text: "48 Tele-consultations / Year (35+ specialties)" },
  { ico: "🛡️", text: "Insurance Cover — up to ₹5 Lacs" },
  { ico: "⌚", text: "GOQii Smart Watch (HR · SpO2 · Sleep · Stress · BP · IP68)" },
];

function makeFeatures(included) {
  return ALL_FEATURES.map((f, i) => ({ ...f, included: included[i] }));
}

export const PLANS = [
  {
    id: "p1",
    image: "https://appcdn.goqii.com/storeimg/80864_1774352330.jpg",
    barClass: "bar-neutral",
    vbadgeClass: "vb-neutral",
    vbadgeText: "No Doctor Consultations",
    name: "Well-being Health Protect Plan",
    nameSub: "(No Doctor Consultations)",
    sku: "GOQii-iadvl-WBL",
    desc: "Core wellness, coaching & diagnostics — without doctor consultations.",
    price: 2799,
    mrp: 12999,
    isPopular: false,
    features: makeFeatures([true, true, true, true, true, false, false, false, false]),
  },
  {
    id: "p2",
    image: "https://appcdn.goqii.com/storeimg/3173_1774353092.jpg",
    barClass: "bar-teal",
    vbadgeClass: "vb-teal",
    vbadgeText: "Standard",
    name: "Well-being Health Protect Plan",
    nameSub: "(Standard)",
    sku: "GOQii-iadvl-HPP",
    desc: "Full coaching & diagnostics plan with in-person and tele-consultations.",
    price: 2999,
    mrp: 12999,
    isPopular: false,
    features: makeFeatures([true, true, true, true, true, true, true, false, false]),
  },
  {
    id: "p3",
    image: "https://appcdn.goqii.com/storeimg/78662_1774353168.jpg",
    barClass: "bar-orange",
    vbadgeClass: "vb-orange",
    vbadgeText: "With Insurance up to 5 Lacs",
    name: "Well-being Health Protect Plan +",
    nameSub: "(with Insurance up to 5 Lacs)",
    sku: "GOQii-iadvl-HPP+",
    desc: "Complete plan with consultations and ₹5 lacs insurance coverage.",
    price: 3999,
    mrp: 15999,
    isPopular: true,
    features: makeFeatures([true, true, true, true, true, true, true, true, false]),
  },
  {
    id: "p4",
    image: "https://appcdn.goqii.com/storeimg/80000_1774353669.jpg",
    barClass: "bar-purple",
    vbadgeClass: "vb-purple",
    vbadgeText: "With GOQii Smart Watch",
    name: "Well-being Health Protect Plan",
    nameSub: "(with GOQii Smart Watch)",
    sku: "GOQii-iadvl-HPP+Watch",
    desc: "Full consultations plan bundled with the GOQii Smart Watch.",
    price: 4999,
    mrp: 15999,
    isPopular: false,
    features: makeFeatures([true, true, true, true, true, true, true, false, true]),
  },
];

export const ADDONS = [
  {
    id: "a1",
    barClass: "ab-1",
    emoji: "👨‍👩‍👧",
    title: "Family Add-on: Plan + (with Insurance)",
    sku: "GOQii-iadvl-C+I",
    basePill: "For 1 additional family member",
    desc: "All base features plus doctor consultations and ₹5 lacs insurance cover for one family member.",
    extras: [
      { cls: "ae-teal", ico: "🩺", text: "In-person & tele-consultations" },
      { cls: "ae-orange", ico: "🛡️", text: "Insurance cover up to ₹5 Lacs" },
    ],
    price: 2999,
    mrp: 5999,
  },
  {
    id: "a2",
    barClass: "ab-2",
    emoji: "👫",
    title: "Family Add-on: Plan (Standard)",
    sku: "GOQii-iadvl-CP",
    basePill: "For 1 additional family member",
    desc: "All base features plus doctor consultations for one family member. Most affordable family extension.",
    extras: [
      { cls: "ae-teal", ico: "🩺", text: "In-person & tele-consultations" },
    ],
    price: 1999,
    mrp: 3999,
  },
  {
    id: "a3",
    barClass: "ab-3",
    emoji: "⌚",
    title: "Family Add-on: Plan (with GOQii Smart Watch)",
    sku: "GOQii-iadvl-CSW",
    basePill: "For 1 additional family member",
    desc: "All base features plus doctor consultations and GOQii Smart Watch for continuous vitals monitoring.",
    extras: [
      { cls: "ae-teal", ico: "🩺", text: "In-person & tele-consultations" },
      {
        cls: "ae-purple",
        ico: "⌚",
        text: "GOQii Smart Watch — HR, SpO2, Sleep, Stress, BP · IP68 · 7-day battery",
      },
    ],
    price: 3999,
    mrp: 6999,
  },
];
